import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  gridItem: {
    display: 'flex',
    zIndex: 3,
  },
  boxH3: {
    color: '#002d5c',
    textAlign: 'center',
    fontWeight: '600',
    fontSize: '1.3rem',
    marginBottom: '1rem',
  },
  boxP: {
    color: '#4B5B69',
    width: '100%',
    textAlign: 'left',
    position: 'relative',
    fontSize: '1.2rem',
    margin: '0',
    lineHeight: '1.2',
  },
  box: {
    padding: theme.spacing(3),
    textAlign: 'center',
    backgroundColor: '#fff',
    borderRadius: '20px',
    border: '2px solid #e5eaf4',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    position: 'relative',
    zIndex: '2',
    transition: 'transform 0.5s',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    height: '100%',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
    },
    '&:hover': {
      // Other hover transformations...
      '& $circleDollarCoin': {
        transform: 'rotateY(360deg)', // Flip coin animation
      },
      '& $microchip': {
        transform: 'rotateY(180deg)', // Flip chip animation
      },
      '& $usersGear': {
        transform: 'rotate(180deg)', // Full clockwise rotation
      },
      '& $pieLarge': {
        transform: 'translate(-27px, 27px)', // Move pie slice
      },
      '& $graphLines': {
        transform: 'scale(1)', // Stretch bars
      },
      '& $globePointer': {
        animation: '$globePointerMove 1s ease-in-out', // Apply animation to move and return
      },
      '& $briefcase': {
        transform: 'translateY(-40px) scale(1)', // Move up and grow a little
      },
      '& $userClock': {
        transform: 'scale(1.3)', // Stretch bars
      },
      '& $calendarClock': {
        transform: 'rotate(-5deg) scale(1)', // Spin counterclockwise by 45 degrees and no scaling
      },
      '& $headset': {
        animation: '$headsetGrow 1s ease-in-out', // Apply animation to move and return
      },
    },
  },
  iconWrapper: {
    backgroundColor: '#002d5c',
    width: '90px',
    height: '90px',
    borderRadius: '50%',
    margin: '0 auto 20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    perspective: '1000px',
  },
  svgIcon: {
    width: '50px',
    height: '50px',
    overflow: 'visible !important',
  },
  circleDollarCoin: {
    transition: 'transform 0.5s',
    transformOrigin: 'center',
    transformStyle: 'preserve-3d',
    backfaceVisibility: 'hidden',
    willChange: 'transform',
  },
  microchip: {
    transition: 'transform 0.8s',
    transformOrigin: 'center',
    transformStyle: 'preserve-3d',
    backfaceVisibility: 'hidden',
    willChange: 'transform',
  },
  pieLarge: {
    transition: 'transform 0.5s ease-in-out',
    willChange: 'transform',
    backfaceVisibility: 'hidden',
  },
  graphLines: {
    transform: 'scaleY(0.8)',
    transformOrigin: 'bottom',
    transition: 'transform 0.5s ease-in-out',
    willChange: 'transform',
  },
  globePointer: {
    transform: 'scaleY(1)',
    transformOrigin: 'bottom',
    transition: 'transform 0.5s ease-in-out',
    willChange: 'transform',
  },
  '@keyframes globePointerMove': {
    '0%': {
      transform: 'translate(0px, 0px)',
    },
    '50%': {
      transform: 'translate(-3px, 3px)',
    },
    '100%': {
      transform: 'translate(0px, 0px)',
    },
  },
  '@keyframes headsetGrow': {
    '0%': {
      transform: 'scale(1)', 
    },
    '50%': {
      transform: 'scale(1.2)', 
    },
    '100%': {
      transform: 'scale(1)', 
    },
  },
  usersGear: {
    transition: 'transform 1s',
    transformOrigin: '80% 75%',
    transformStyle: 'preserve-3d',
    backfaceVisibility: 'hidden',
    willChange: 'transform',
  },
  briefcase: {
    transition: 'transform 0.5s',
  },
  userClock: {
    transition: 'transform 1s',
    transformOrigin: 'center bottom',
  },
  calendarClock: {
    transition: 'transform 0.7s',
    transformOrigin: 'top right',
    willChange: 'transform',
  },
  headset: {
    transition: 'transform 0.7s',
    transformOrigin: 'center center',
    willChange: 'transform',
  },
}));
